import { LogLevel, PublicClientApplication } from '@azure/msal-browser';

// See https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
export const msalRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
  prompt: 'select_account',
};

// See https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: 'f82496b8-6da1-435b-bb4b-27d33db4269c',
    authority: 'https://login.microsoftonline.com/common',
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message) => {
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          case LogLevel.Trace:
            console.info(message);
            return;
          default:
            return;
        }
      },
    },
  },
});

// See https://console.cloud.google.com/apis/credentials/oauthclient/318421565490-11c7r5pm83ljcm34l2brlkefhbsrunck.apps.googleusercontent.com?authuser=2&project=vital-petal-368017&rapt=AEjHL4NmRCHzj79kwuqNxn-lKqOZv3An5I2qALc360EZQ-qR8dnq76-TcZVU8fDnQQXlgODPPk-cTivxzKYspeRnhbIKR80En3e89fXwZAGhe6jpOXoWu_U
export const googleClientID =
  '318421565490-11c7r5pm83ljcm34l2brlkefhbsrunck.apps.googleusercontent.com';
